import { Link, Outlet } from 'react-router';

import { Waves } from '../../design/Waves.tsx';
import { OfflineBanner } from '../../shell/OfflineBanner.tsx';
import styles from './AuthLayout.module.css';

// Signed out (design: AUTH + MARKETING): on tablet and desktop a brand panel
// with what Guildite is sits beside the form; phones show only the form.
export function AuthLayout() {
  return (
    <div className={styles.layout}>
      <a className="skip-link" href="#main">Skip to content</a>
      <aside className={styles.brand}>
        <Waves tone="brand" />
        <div className={styles.brandText}>
          <Link to="/" className={styles.wordmark}>guildite</Link>
          <p className={styles.headline}>Buy from people you trust, wherever you are.</p>
          <p><b>Guilds.</b> Groups for your campus, town or passion, with chat and drops.</p>
          <p><b>Pay safely.</b> MoMo and cards through Paystack, plus a code you give only at delivery.</p>
          <p><b>One account.</b> Post, shop, open a shop or deliver as a rider.</p>
          <p className={styles.note}>Use it right here in your browser on any phone or computer, or add it to your home screen.</p>
        </div>
      </aside>
      <main id="main" className={styles.form}>
        <OfflineBanner />
        <Outlet />
      </main>
    </div>
  );
}
